module.exports = __webpack_public_path__ + "static/ogimage-v3-d9f88425bd598b0fe0be16363cfe144c.png";